import { render, staticRenderFns } from "./loading-dialog.vue?vue&type=template&id=0ef84562"
import script from "./loading-dialog.vue?vue&type=script&lang=js"
export * from "./loading-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports